import styled, { css } from "styled-components";
import { Box, Typography } from "@mui/material";

interface ICardContainer {
	image?: string;
	filter?: number;
}

interface IRewardItem {
	width?: string;
	filter?: number;
}

interface IItems {
	isOffer?: boolean;
}

interface IDescription {
	variant?: string;
}

export const Container = styled.div<ICardContainer>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	background-image: url(${(props) => props.image});
	filter: grayscale(0);
	background-repeat: no-repeat;
	background-position: top center;
	background-size: cover;
	width: 15em;
	height: 15em;

	@media (min-width: 734px) {
		width: 22.66em;
		height: 22.66em;
	}
`;

export const DescriptionContainer = styled.div`
	height: 28.42%;
	width: 100%;
	display: flex;
	justify-content: end;
	align-items: center;
	flex-direction: column;
`;

export const Percentage = styled.div`
	color: #fff;
	text-align: center;
	text-shadow: -0.07em -0.07em 0 #593113, 0.07em -0.07em 0 #593113,
		-0.07em 0.07em 0 #593113, 0.13em 0.13em 0 #593113;
	font-weight: 400;
	font-family: Baloo;
	font-size: 1.5em;
	font-style: normal;
	z-index: 500;
	line-height: 100%;
	height: 30%;
	width: 5.33em;

	@media (min-width: 734px) {
		font-size: 2.27em;
		width: 3.52em;
	}
`;

export const Description = styled.div<IDescription>`
	color: #fff;
	text-shadow: -0.09em -0.09em 0 #593113, 0.09em -0.09em 0 #593113,
		-0.09em 0.09em 0 #593113, 0.18em 0.18em 0 #593113;
	font-weight: 400;
	font-family: Baloo;
	font-style: normal;
	z-index: 500;
	font-size: 1.13em;
	line-height: 100%;
	height: 32%;
	display: flex;
	align-items: center;
	justify-content: center;

	${(props) => {
		switch (props.variant) {
			case "item":
				return css`
					height: 25%;
				`;
			case "freeItem":
				return css`
					height: 40%;
				`;
			default:
				break;
		}
	}}

	@media (min-width: 734px) {
		height: 36%;
		font-size: 1.7em;
		${(props) => {
			switch (props.variant) {
				case "item":
					return css`
						height: 25%;
					`;
				case "freeItem":
					return css``;
				default:
					break;
			}
		}}
	}
`;

export const Items = styled.div<IItems>`
	justify-content: center;
	align-items: center;
	display: flex;
	z-index: 500;
	height: ${(props) => (props.isOffer ? "52.79%" : "61%")};
`;

export const RewardItem = styled.div<IRewardItem>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	padding: 0.1em;
	filter: grayscale(${(props) => props.filter});
`;

export const RewardAmount = styled(Typography)`
	color: #fff;
	font-weight: 700;
	font-size: 1.2em;

	@media (min-width: 734px) {
		font-size: 1.6em;
	}
`;

export const ItemImage = styled.img<{ loyaltyBoxExtraMessage?: boolean }>(
	({ loyaltyBoxExtraMessage }) => `
	width: ${loyaltyBoxExtraMessage ? "2.44em" : "3.38em"};
	height: ${loyaltyBoxExtraMessage ? "2.44em" : "3.38em"};
	object-fit: contain;
	justify-self: center;
	align-self: center;
	@media (min-width: 734px) {
		width: ${loyaltyBoxExtraMessage ? "3.4em" : "4.53em"};
		height: ${loyaltyBoxExtraMessage ? "3.4em" : "4.53em"};
	}
`
);

export const LockIcon = styled.img`
	position: absolute;
	top: 30%;
	right: -7%;
	height: 75%;
	z-index: 1000;

	@media (min-width: 734px) {
		right: -9%;
	}
`;

export const InfoBox = styled(Box)<{ loyaltyBoxExtraMessage?: boolean }>(
	({ loyaltyBoxExtraMessage }) => `
	background-color: rgb(0 0 0 / 30%);
	border-radius: 999em;
	color: white;
	font-weight: 220;
	opacity: 0.9;
	padding: ${loyaltyBoxExtraMessage ? "0.1em 0.7em" : "0.3em 0.7em"};
	position: absolute;
	background-repeat: no-repeat;

`
);

export const LoyalBox = styled(InfoBox)`
	background-position: 90% center;
	color: white;
	padding-right: 2em;
	background-color: white;
	white-space: nowrap;
	> div {
		align-items: center;
		justify-content: center;
		display: flex;
		gap: 0.2em;
	}
`;

export const LoyalBoxWrap = styled(Box)<{ loyaltyBoxExtraMessage?: boolean }>(
	({ loyaltyBoxExtraMessage }) => `
	bottom: ${loyaltyBoxExtraMessage ? "12%" : "9%"};
	display: flex;
	font-size: 0.5em;
	justify-content: center;
	position: relative;
`
);
